var map = {
	"./btn-background-black.png": 241,
	"./btn-background-green.png": 242,
	"./delete-purple.png": 1556,
	"./delete-white.png": 1557,
	"./dog-video-bck.png": 243,
	"./dog-video.png": 1558,
	"./fast-betting-btn-purple.png": 1559,
	"./fast-betting-btn.png": 104,
	"./first-dog.png": 1560,
	"./header-babaijebu.png": 244,
	"./hr-blue-btn.png": 1561,
	"./second-dog.png": 1562,
	"./third-dog.png": 1563,
	"./vdh-bck.png": 157,
	"./vdh-progress.png": 245
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1555;


//////////////////
// WEBPACK FOOTER
// ./src/games/dog-racing/img \.(gif|png|jpe?g|svg)$/
// module id = 1555
// module chunks = 8